import React from "react";
import MinistryLogo from "../assets/Images/ministry-logo.png";
import AltenLogo from "../assets/Images/alten-logo.png";
import NRLogo from "../assets/Images/nr-logo.png";
import MinistryEducationLogo from "../assets/Images/ministry-education-logo.png";
import InfoMarketLogo from "../assets/Images/infomarket-logo.png";

const Experience = () => {
  const experiences = [
    {
      title: "IT Project Coordinator",
      company: "Ministry of Equipment and Water",
      logo: MinistryLogo,
      duration: "February 2020 - Present",
      points: [
        "Coordinated IT projects at the regional level (Rabat-Salé-Kénitra).",
        "Monitored and managed the operation of information systems.",
        "Active member of the National Information Systems Security Committee.",
        "Ensured the integrity and protection of sensitive data.",
      ],
    },
    {
      title: "Technical Support Specialist",
      company: "ALTEN MAROC",
      logo: AltenLogo,
      duration: "December 2019 - January 2020",
      points: [
        "Resolved client complaints regarding ADSL, FTTH, VOIP, and IPTV services.",
        "Performed analysis, diagnostics, and incident resolution within tight deadlines.",
      ],
    },
    {
      title: "IT Intern",
      company: "NR-Equipement",
      logo: NRLogo,
      duration: "July 2019 - September 2019",
      points: [
        "Handled IT maintenance and infrastructure management.",
        "Developed an inventory project for IT equipment to improve resource management.",
      ],
    },
    {
      title: "Application Development Intern",
      company: "Ministry of Higher Education",
      logo: MinistryEducationLogo,
      duration: "April 2019 - June 2019",
      points: [
        "Developed a desktop application for IT inventory and maintenance management.",
        "Integrated a database to centralize maintenance information.",
      ],
    },
    {
      title: "Intern - Introduction to IT",
      company: "InfoMarket",
      logo: InfoMarketLogo,
      duration: "August 2018",
      points: [
        "Gained foundational knowledge in IT maintenance and information systems.",
      ],
    },
  ];

  return (
    <section id="experience" className="py-16 px-6 bg-gray-50">
      <div className="container mx-auto max-w-7xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-800">Professional Experience</h1>
          <p className="text-lg text-dark-orange mt-4">Explore my career journey</p>
        </div>

        {/* Experience Timeline */}
        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 w-1 h-full bg-gray-300"></div>
          <div className="grid gap-12 lg:grid-cols-2">
            {experiences.map((exp, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-duration="1000"
                className={`flex flex-col lg:flex-row items-center lg:items-start space-y-6 lg:space-y-0 lg:space-x-8 ${
                  index % 2 === 0 ? "lg:justify-end" : "lg:justify-start"
                }`}
              >
                <div className="flex-shrink-0 w-20 h-20 lg:w-24 lg:h-24">
                  <img
                    src={exp.logo}
                    alt={exp.company}
                    className="w-full h-full rounded-lg object-cover border border-gray-300 shadow-md"
                  />
                </div>
                <div className="max-w-lg bg-white p-6 shadow-lg rounded-lg transition transform hover:scale-105 hover:shadow-xl">
                  <h2 className="text-xl font-semibold text-gray-800">{exp.title}</h2>
                  <p className="text-gray-600 font-medium mt-1">{exp.company}</p>
                  <p className="text-sm text-gray-500 mt-1">{exp.duration}</p>
                  <ul className="list-disc pl-5 space-y-2 text-gray-700 text-sm md:text-base mt-4">
                    {exp.points.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
